import clsx from 'clsx';
import React from 'react';

import useEventTracking from '@hooks/useEventTracking';
import { Theme } from '@interfaces/global';
import { subscriber_profile_path } from '@routes';
import { ClickTarget, click } from '@tracking';

import { Author } from '../../interfaces/authors';
import AuthorTooltip from '../AuthorTooltip';

interface NameItemProps {
  author: Author;
  className?: string;
  theme?: Theme;
  withTooltip?: boolean;
}

const NameItem = ({ author, className, theme, withTooltip }: NameItemProps) => {
  const { Track, trackEvent } = useEventTracking({
    creatorIds: [author.id],
  });

  return (
    <Track>
      <div className="group relative inline-block">
        <a
          href={author.username ? subscriber_profile_path(author.username) : ''}
          className={clsx('transition-colors duration-200 hover:text-primary-magenta', className, {
            'text-white': theme === Theme.Dark,
            'text-black': theme === Theme.Light,
          })}
          onClickCapture={() =>
            trackEvent(click({ clickTarget: ClickTarget.Author, clickText: author.name }))
          }
        >
          {author.name}
        </a>
        {withTooltip && (
          <AuthorTooltip
            email={author.email}
            isExternalAuthor={author.isExternalAuthor}
            profileEnabled={author.profileEnabled}
            twitter={author.twitter}
            username={author.username}
          />
        )}
      </div>
    </Track>
  );
};

export default NameItem;
